import React from "react";

import {
  Textarea as SharedTextarea,
  TextareaProps as SharedTextareaProps,
} from "@sportal/cdk/textarea";

import "./Textarea.scss";

interface TextareaProps extends SharedTextareaProps {}

export const Textarea = ({
  showLimit = true,
  maxLength,
  className,
  ...props
}: TextareaProps) => {
  return (
    <SharedTextarea
      {...props}
      className={className}
      showLimit={showLimit && maxLength > 0}
      maxLength={maxLength}
    />
  );
};
